var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "close@1x-a",
          d:
            "M13.4157983,12.0040916 L17.7157983,7.71409163 C18.1079205,7.32196946 18.1079205,6.6862138 17.7157983,6.29409163 C17.3236762,5.90196946 16.6879205,5.90196946 16.2957983,6.29409163 L12.0057983,10.5940916 L7.71579832,6.29409163 C7.32367615,5.90196947 6.6879205,5.90196947 6.29579833,6.29409164 C5.90367617,6.68621381 5.90367616,7.32196946 6.29579832,7.71409163 L10.5957983,12.0040916 L6.29579832,16.2940916 C6.10648567,16.4818582 6,16.7374541 6,17.0040916 C6,17.2707292 6.10648567,17.526325 6.29579832,17.7140916 C6.48356492,17.9034043 6.73916079,18.00989 7.00579832,18.00989 C7.27243586,18.00989 7.52803172,17.9034043 7.71579832,17.7140916 L12.0057983,13.4140916 L16.2957983,17.7140916 C16.4835649,17.9034043 16.7391608,18.00989 17.0057983,18.00989 C17.2724359,18.00989 17.5280317,17.9034043 17.7157983,17.7140916 C17.905111,17.526325 18.0115966,17.2707292 18.0115966,17.0040916 C18.0115966,16.7374541 17.905111,16.4818582 17.7157983,16.2940916 L13.4157983,12.0040916 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#close@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }